import { useState, useEffect, useRef, createRef, useContext } from 'react'
import {
    ArrowPathRoundedSquareIcon, XCircleIcon,
    CloudArrowDownIcon, PauseCircleIcon,
    ArrowDownOnSquareIcon, MagnifyingGlassIcon, ChevronRightIcon, CheckIcon, XMarkIcon, ArrowLeftIcon, ChevronLeftIcon
} from "@heroicons/react/20/solid"

import { motion, useAnimationControls, useDragControls, AnimatePresence } from "framer-motion"

import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/zh-cn'
import "./main.css"
import { ReactComponent as PhoneIcon } from './phone.svg'
import { ReactComponent as EmailIcon } from './email.svg'
import { ReactComponent as WechatIcon } from './wechat.svg'
import { ReactComponent as CustomerServiceIcon } from './customer_service.svg'
import LogoIcon from './logo.png';
import { language_ch, language_en } from "./language"
import { Routes, Route, useParams, useNavigate } from 'react-router-dom';

dayjs.extend(relativeTime)
dayjs.locale("zh-cn")


export default function FeekbackPage(props) {

    let { device, language } = useParams()
    if (!language) {
        language = "ch"
    }
    var languagePackage = language === "ch" ? language_ch : language_en

    const [containerMaxHeight, setContainerMaxHeight] = useState(null)
    // boarding:"true", "no", "noTest"
    const [boarding, setBoarding] = useState("noTest")
    const [cameraName, setCameraName] = useState("")
    const [lensName, setLensNames] = useState("")
    const [feekback, setFeekback] = useState("")
    const [contact, setContact] = useState("")
    const [loading, setLoading] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [modalMsg, setModalMsg] = useState(false)

    const [showSheet, setShowSheet] = useState(false)
    const [pushSheet, setPushSheet] = useState(false)

    const navigate = useNavigate();

    const checkRuleNoBack = cameraName == "" || lensName == "" ? true : false
    const checkTextStyle = {
        opacity: checkRuleNoBack ? 0.5 : 1
    }

    useEffect(() => {
        setContainerMaxHeight(window.innerHeight)
    }, [])

    async function sendFeekback() {

        if (!cameraName) {
            setShowModal(true)
            setModalMsg(languagePackage.Feedback.please_enter_the_camera_model)
            return
        }

        if (!feekback) {
            setShowModal(true)
            setModalMsg(languagePackage.Feedback.please_enter_feedback_information)
            return
        }

        if (!contact) {
            setShowModal(true)
            setModalMsg(languagePackage.Feedback.please_enter_contact_information)
            return
        }

        const phone = contact.includes("@") ? "" : contact
        const email = contact.includes("@") ? contact : ""
        const feedback = feekback
        var boardingWithNoTest = boarding
        if (boarding ==="noTest") {
            boardingWithNoTest = "false"
        } 

        const body = JSON.stringify({
            gimbalName: device,
            boarding:boardingWithNoTest,
            cameraName,
            lensName,
            feedback,
            phone,
            email
        })

        try {
            setLoading(true)
            const res = await fetch("http://180.140.115.231:9080/api/app/feedbackmail/send",
                { method: "POST", headers: { "Content-Type": "application/json" }, mode: 'cors', body })
            const json = await res.json()
            console.log(json)
            setLoading(false)
            setShowModal(true)
            if (json.code == 0) {
                setModalMsg(languagePackage.Feedback.thanks_for_your_feedback)
            } else {
                setModalMsg(languagePackage.Feedback.intent_error_please_try_again)
            }
        } catch (error) {
            setLoading(false)
            setShowModal(true)
            setModalMsg(languagePackage.Feedback.intent_error_please_try_again)
        }
    }

    function makePhoneCall() {
        let a = window.document.createElement("a")
        a.href = "tel:400-990-6118"
        a.click()
    }

    function sendEmail() {
        let a = window.document.createElement("a")
        a.href = "mailto:service@feiyu-tech.com"
        a.click()
    }

    function goCustomerService() {
        let a = window.document.createElement("a")
        a.href = "https://chatbot.aliyuncs.com/intl/index.htm?locale=zh-CN&from=U46pryVb2z"
        a.click()
    }

    function replaceByCameraNameAndLensName() {
        setBoarding(boarding => "noTest")
        setFeekback("")
        setContact("")
    }

    async function copyWechat() {
        await navigator.clipboard.writeText("飞宇");
        setShowModal(true)
        setModalMsg(languagePackage.Feedback.wechat_copyed)
        setTimeout(() => {
            window.location.href = "weixin://";//打开微信
        }, 1000 * 3)
    }




    return (
        <>
            <div class=" absolute w-full h-[350px] bg-gradient-to-b from-sky-500 to-slate-100 z-0" ></div>

            <div
                style={containerMaxHeight ? { height: containerMaxHeight } : null}
                class="w-full h-full overflow-auto overflow-x-hidden z-50 absolute"
            >
                <div class=" flex flex-row justify-start ">
                    <div className='btn btn-square btn-sm ml-2 bg-white mt-3'
                        onClick={e => {
                            navigate(-1)
                        }}
                    >
                        <ChevronLeftIcon className='w-8 h-8 text-blue-500' />
                    </div>
                </div>
                <div class="feekback-title w-full h-24 mx-5 flex flex-row justify-between items-start">
                    <div class="flex h-24 flex-col justify-center items-start text-white">
                        <label class="text-md font-bold">{languagePackage.Feedback.main_title}</label>
                        <label class="text-sm mt-1">{languagePackage.Feedback.sub_title}</label>
                    </div>
                    <img class="block w-36 mr-10 object-contain" src={LogoIcon}></img>
                </div>
                <div className="card  mx-5 bg-base-100 shadow-xl">
                    <div className="card-body">
                        <div className="form-control">
                            <div class="flex justify-between items-center " >
                                <label class=" w-16 text-sm font-bold">{languagePackage.Feedback.camera_name}</label>
                                <input type="text" placeholder={languagePackage.Feedback.camera_name_placeholder}
                                    value={cameraName}
                                    onChange={
                                        e => {
                                            setCameraName(e.target.value)
                                            if (e.target.value == "" || lensName == "") {
                                                replaceByCameraNameAndLensName()
                                            } 
                                        }
                                    }
                                    className="input input-sm text-right  max-w-xs" />
                            </div>
                            <DividingLine />
                            <div class="flex justify-between items-center " >
                                <label class=" w-16 text-sm font-bold">{languagePackage.Feedback.lens_name}</label>
                                <input type="text" placeholder={languagePackage.Feedback.lens_name_placeholder}
                                    value={lensName}
                                    onChange={
                                        e => {
                                            setLensNames(e.target.value)
                                            if (cameraName == "" || e.target.value == "") {
                                                replaceByCameraNameAndLensName()
                                            } 
                                        }
                                    }
                                    className="input input-sm text-right  max-w-xs" />
                            </div>
                            <DividingLine />
                            <div class="flex justify-between items-center" >
                                <label class=" text-sm font-bold" style={checkTextStyle}>{languagePackage.Feedback.boarding}</label>
                                <label className="cursor-pointer label">
                                    <input
                                        type="checkbox"
                                        onChange={e => {
                                            setBoarding(boarding => "true")
                                        }}
                                        checked={boarding == "true"}
                                        className="checkbox checkbox-info checkbox-xs ml-4" style={checkTextStyle} disabled={checkRuleNoBack}/>
                                    <span className="ml-1 label-text" style={checkTextStyle}>{languagePackage.Feedback.yes}</span>
                                    <input 
                                        type="checkbox"
                                        onChange={e => {
                                            setBoarding(boarding => "no")
                                        }}
                                        checked={boarding == "no"}
                                        className="checkbox checkbox-info checkbox-xs ml-4" style={checkTextStyle} disabled={checkRuleNoBack}/>
                                    <span className="ml-1 label-text" style={checkTextStyle}>{languagePackage.Feedback.no}</span>
                                    <input
                                        type="checkbox"
                                        onChange={e => {
                                            setBoarding(boarding => "noTest")
                                        }}
                                        checked={boarding == "noTest"}
                                        className="checkbox checkbox-info checkbox-xs ml-4" style={checkTextStyle}/>
                                    <span className="ml-1 label-text" style={checkTextStyle}>{languagePackage.Feedback.no_test}</span>
                                </label>
                            </div>
                            <DividingLine />
                            <div class="" >
                                <label class=" w-16 text-sm font-bold" style={checkTextStyle}>{languagePackage.Feedback.feedback}</label>
                                <textarea className="textarea textarea-bordered w-full mt-3 h-36"
                                    placeholder={languagePackage.Feedback.feedback_describe}
                                    value={feekback}
                                    onChange={e => setFeekback(e.target.value)}
                                    disabled={checkRuleNoBack}
                                ></textarea>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="card mt-3 mx-5 bg-base-100 shadow-xl">
                    <div className="card-body p-3">
                        <div class="flex justify-between items-center " >
                            <label class="ml-4 w-16 text-sm font-bold" style={checkTextStyle}>{languagePackage.Feedback.contact}</label>
                            <input type="text" placeholder={languagePackage.Feedback.phone_or_email} className="input input-sm text-right  max-w-xs"
                                value={contact}
                                onChange={e => setContact(e.target.value)}
                                disabled={checkRuleNoBack}
                            />
                        </div>
                    </div>
                </div>
                <div className="card my-3 mx-5 bg-base-100 shadow-xl">
                    <div className="card-body">
                        <div className="form-control">
                            <div class="flex justify-start items-center" >
                                <label class=" text-sm font-bold">{languagePackage.Feedback.feedback_way}</label>
                            </div>
                            <DividingLine />
                            <div class="flex justify-between items-center "
                            // onClick={e => makePhoneCall()}
                            >
                                <PhoneIcon className='w-8 shrink-0' />
                                <div class="flex flex-col justify-between items-start mx-2" >
                                    <label class="text-xs text-gray-500">{languagePackage.Feedback.by_phone}</label>
                                    <label class="text-sm font-bold">400-990-6118</label>
                                    <label class="text-xs text-gray-500">{languagePackage.Feedback.work_time}</label>
                                </div>
                                <ChevronRightIcon className='w-5 h-5 shrink-0' />
                            </div>
                            <DividingLine />
                            <div class="flex justify-between items-center "
                            // onClick={e => sendEmail()}
                            >
                                <EmailIcon className='w-8 shrink-0' />
                                <div class="flex flex-col justify-between items-start mx-2" >
                                    <label class="text-xs text-gray-500">{languagePackage.Feedback.by_email}</label>
                                    <label class="text-sm font-bold">Email: service@feiyu-tech.com</label>
                                    <label class="text-xs text-gray-500">{languagePackage.Feedback.work_time}</label>
                                </div>
                                <ChevronRightIcon className='w-5 h-5 shrink-0' />
                            </div>
                            <DividingLine />
                            <div class="flex justify-between items-center "
                            // onClick={e => copyWechat()}
                            >
                                <WechatIcon className='w-8 shrink-0' />
                                <div class="flex flex-col justify-between items-start mx-2" >
                                    <label class="text-xs text-gray-500">{languagePackage.Feedback.by_wechat}</label>
                                    <label class="text-sm font-bold">{languagePackage.Feedback.by_wechat_describe}</label>
                                    <label class="text-xs text-gray-500">{languagePackage.Feedback.work_time}</label>
                                </div>
                                <ChevronRightIcon className='w-5 h-5 shrink-0' />
                            </div>
                            <DividingLine />
                            <div class="flex justify-between items-center "
                                // onClick={e => goCustomerService()}
                                onClick={e => {
                                    setShowSheet(true)
                                    setPushSheet(true)
                                }}
                            >
                                <CustomerServiceIcon className='w-8 shrink-0' />
                                <div class="flex flex-col justify-between items-start mx-2" >
                                    <label class="text-xs text-gray-500">{languagePackage.Feedback.online_customer_service}</label>
                                    <label class="text-sm font-bold">{languagePackage.Feedback.online_customer_service_describe}</label>
                                    <label class="text-xs text-gray-500">{languagePackage.Feedback.work_time}</label>
                                </div>
                                <ChevronRightIcon className='w-5 h-5 shrink-0' />
                            </div>

                        </div>


                    </div>
                </div>

                <div className='w-full flex justify-center items-center'>
                    <button
                        onClick={e => sendFeekback()}
                        className="btn btn-info btn-sm rounded-full text-white w-64 mt-6 mb-10 h-10" >{languagePackage.Feedback.submit}</button>
                </div>


                <div
                    style={showSheet ? { display: "block" } : { display: "none" }}
                    className='w-full h-full fixed z-50 top-0 left-0'
                    onClick={() => {
                        setPushSheet(false)
                        setTimeout(() => setShowSheet(false), 250)
                    }}
                >
                    <motion.div
                        animate={pushSheet ? { bottom: 0 } : { bottom: -420 }}
                        style={{ height: "420px", backgroundColor: "#f0f2f6" }}
                        className='bg-base-100 w-full  fixed bottom-0  rounded-t-2xl p-5 shadow-[0_35px_60px_15px_rgba(0,0,0,0.3)]'>
                        <div className='w-full text-center  font-bold pt-0'>

                        </div>
                        <div
                            class="w-full h-full sheet-content overflow-y-scroll overflow-x-hidden pb-5" >
                            <iframe

                                className='w-full h-full '
                                src="https://chatbot.aliyuncs.com/intl/index.htm?locale=zh-CN&from=U46pryVb2z"></iframe>

                        </div>
                    </motion.div>
                </div>

            </div>
            {loading &&
                <div class="fixed top-0 left-0 w-full h-full bg-black opacity-50 flex justify-center items-center z-99" >
                    <span className="loading loading-ring loading-lg text-primary"></span>
                </div>
            }
            {showModal &&
                <dialog id="my_modal_1" className={showModal ? "modal modal-open" : "modal"} >
                    <form method="dialog" className="modal-box">
                        <h3 className="font-bold text-lg">{languagePackage.Feedback.notice}</h3>
                        <p className="py-4">{modalMsg}</p>
                        <div className="modal-action">

                            <button className="btn"
                                onClick={e => {
                                    setShowModal(false)
                                    if (languagePackage.Feedback.thanks_for_your_feedback == modalMsg) {
                                        setTimeout(e => navigate(-1), 258)
                                    }
                                }}
                            >{languagePackage.Feedback.close}</button>
                        </div>
                    </form>
                </dialog>
            }
        </>

    )

}


function DividingLine() {
    return <div className="h-[1px] bg-gray-200 my-2"></div>
}
